<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'400px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <h3 class="dialogTitle margin-left-5">Chọn định dạng file</h3>
        <!--        <el-radio-group v-model="fileType">-->
        <!--          <el-radio label="PDF">PDF</el-radio>-->
        <!--          <el-radio label="DOCX" aria-checked="true">DOCX</el-radio>-->
        <!--          <el-radio label="XLSX" aria-checked="true">XLSX</el-radio>-->
        <!--        </el-radio-group>-->
        <div class="radio-menu-item">

          <div>
            <a href="#">
              <span @click="download('PDF')">Download</span>
              <span >PDF</span>
            </a>
            <a href="#" >
              <span @click="download('DOCX')">Download</span>
              <span>WORD</span>
            </a>
            <a href="#" >
              <span @click="download('XLSX')">Download</span>
              <span>EXCEL</span>
            </a>
          </div>
        </div>
        <br>

      </template>

      <template #footer>
        <div class="flex-row flex__right form-button__action margin-top-10">
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="$emit('closeDialog')"
          >
            <span class="flex-row flex__center">
              <i class="far fa-times-circle font-size__medium"></i>
              &nbsp;&nbsp;Hủy
            </span>
          </el-button>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>


export default {
  name: "chosen-file-type-dialog",
  props: ["isOpen"],
  components: {
    dialogTemplate: () => import("../../../src/views/common/custom-dialog.vue"),
  },
  computed: {},
  data() {
    return {
      isEnableSelectDepartmentDialog: false,
      isOpenDialogCreate: true,
      fileType: 'PDF',
    };
  },

  created() {
  },
  watch: {},
  methods: {
    save() {
      console.log('this.fileType', this.fileType)
      this.$emit('exportResult', this.fileType);
    },

    download(fileType) {
      this.fileType=fileType;
      console.log('this.fileType', this.fileType)

      this.$emit('exportResult', this.fileType);
    }
  }
}
</script>

<style scoped>
.radio-menu-item {
  display: flex;
  justify-content: space-around;
}

img:hover {
  cursor: pointer;
  border: 1px solid #fff;
  box-shadow: 0 0 3px 3px #005799;
}

.input-hidden {
  position: absolute;
  left: -9999px;
}

input[type=radio]:checked + label > img {
  border: 1px solid #fff;
  box-shadow: 0 0 3px 3px #090;
}

/* Stuff after this is only to make things more pretty */
input[type=radio] + label > img {
  /*border: 1px dashed #444;*/
  width: 60px;
  height: 60px;
  transition: 500ms all;
}

input[type=radio]:checked + label > img {
  transform: rotateZ(-10deg) rotateX(10deg);
}

/*
 | //lea.verou.me/css3patterns
 | Because white bgs are boring.
*/
html {
  background-color: #fff;
  background-size: 100% 1.2em;
  background-image: linear-gradient(
    90deg,
    transparent 79px,
    #abced4 79px,
    #abced4 81px,
    transparent 81px
  ),
  linear-gradient(
    #eee .1em,
    transparent .1em
  );
}

a {
  background: #ffffff;
  border: solid 1px #e6e6e6;
  border-radius: 2px;
  display: inline-block;
  height: 50px;
  line-height: 50px;
  margin: 5px;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 90px;
}

a span {
  background: #014188;
  border-radius: 4px;
  color: #ffffff;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  line-height: normal;
  padding: 5px 10px;
  position: relative;
  text-transform: uppercase;
  z-index: 1;
}

a span:last-child {
  margin-left: -20px;
}

a:before,
a:after {
  border: solid 3px #9fb4cc;
  border-radius: 4px;
  content: '';
  display: block;
  height: 35px;
  left: 50%;
  margin: -17px 0 0 -12px;
  position: absolute;
  top: 50%;
  /*transform:translate(-50%,-50%);*/

  width: 25px;
}

a:hover:before,
a:hover:after {
  background: #e2e8f0;
}

/*a:before{transform:translate(-30%,-60%);}*/

a:before {
  margin: -23px 0 0 -5px;
}

a:hover {
  background: #e2e8f0;
  border-color: #9fb4cc;
}

a:active {
  background: #dae0e8;
  box-shadow: inset 0 2px 2px rgba(0, 0, 0, .25);
}

a span:first-child {
  display: none;
}

a:hover span:first-child {
  display: inline-block;
}

a:hover span:last-child {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/chosenFileTypeDialog.vue